import { createTheme } from '@mui/material/styles';

// DeepAlert brand theme. The primary blue matches the certificate accent
// (#0054A6) so buttons, icons and links are brand-consistent app-wide.
const theme = createTheme({
  palette: {
    primary: {
      main: '#0054A6',
      dark: '#00386e',
      light: '#3a7bc8',
      contrastText: '#ffffff',
    },
  },
});

export default theme;
